import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-text-effect',
  templateUrl: './text-effect.component.html',
  styleUrls: ['./text-effect.component.css']
})
export class TextEffectComponent implements OnInit {
  @Input() input: string;
  selectedArray = [];
  Array2 = [];

  ngOnInit(): void {
    this.checkRequiredField(this.input);
    this.getArrayValues(0);
  }

  getArrayValues(index): void {
    for (let i = 0; i < this.input.length; i++) {
      this.Array2.push(this.input.charAt(i));
    }

    setInterval(() => {
      if (index === this.Array2.length) {
        return;
      }
      this.selectedArray.push(this.Array2[index]);
      index++;
    }, 150);
  }

  checkRequiredField(input: string): void {
    if (input === undefined) {
      throw new Error('Attribute \'input\' is required');
    }
  }
}
